import { Component, AfterViewInit, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';

import { BrowserService } from '../browser.service';

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss']
})
export class HeroComponent implements AfterViewInit {

  public element: any;
  public sidePanel: any;
  public pics = [];
  private animationFrame: number = null;
  private requestAnimationFrame = window.requestAnimationFrame;

  noWebp = false;

  private cancelAnimationFrame = window.cancelAnimationFrame;

  @ViewChild('preview', { static: false }) public previewElement!: any;
  @ViewChild('previewFrame', { static: false }) public previewFrameElement!: any;

  mode:'static'|'preview' = 'static';

  constructor(private el: ElementRef, private cdRef : ChangeDetectorRef, private browserService: BrowserService) {
    this.element = el.nativeElement;
    this.browserService.addLoadListener(() => {
      this.noWebp = !this.browserService.supportsWebp();
    });
  }

  setVisiblePic(visiblePic) {
    for (let i = 0; i < this.pics.length; i++) {
      this.pics[i].style.opacity = visiblePic === i ? 1 : 0;
    }
  }

  ngAfterViewInit() {
    this.sidePanel = this.element.querySelector('.sidePanelContent');

    this.pics.push(this.element.querySelector('.background1'));
    this.pics.push(this.element.querySelector('.background2'));




    const bgObj = this.sidePanel;

    const execute = () => {

        if (bgObj == null) {
          return;
        }

        if (window.innerWidth < 768) {
          bgObj.style.transform = null;
          this.setVisiblePic(0);
          return;
        }

        let distance = Math.min(1.32, window.scrollY / window.innerHeight);
        distance = distance / 2;

        let visiblePic = 0;
        if (distance < 0.2) {
          visiblePic = 0;
        } else {
          visiblePic = 1;
        }
        this.setVisiblePic(visiblePic);



        const callback = () => {
          bgObj.style.transform = 'translate3d(0, -' + (distance * bgObj.clientHeight / 4) + 'px, 0)';
        };

        if (typeof this.requestAnimationFrame !== 'undefined' && this.requestAnimationFrame != null) {
          if (typeof this.cancelAnimationFrame !== 'undefined' && this.animationFrame != null) {
            this.cancelAnimationFrame(this.animationFrame);
          }
          this.animationFrame = this.requestAnimationFrame(callback);
        } else {
          callback();
        }


    };

    window.document.addEventListener('scroll', () => {
      execute();
    });

    execute();
  }

  getPreviewWidth = () => {
    if(this.previewElement) {
      return this.previewElement?.nativeElement.clientWidth;
    }
    return 0;
  }

  getPreviewHeight = () => {
    if(this.previewElement) {
      return this.previewElement?.nativeElement.clientHeight;
    }
    return 0;
  }

  getIframeWidth = () => {
    return 1024;//Math.min(this.getPreviewWidth(), this.previewElement?.nativeElement.clientHeight * 1.7777777777777777777777777777778);
  }

  getIframeHeight = () => {
    return 768;
  }

  getScaleFactor = () => {
    console.log('getScaleFactor', this.getIframeWidth(), this.getPreviewWidth());
    return this.getPreviewWidth() / this.getIframeWidth();
  }

  activatePreview = () => {
    this.mode = 'preview';
    this.cdRef.detectChanges();
  }

}
